import { Fragment } from "react";

import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { PageStatus } from "@framework/types";
import { DialogMode } from "@framework/shared";

export interface IPageDialogFormProps {
  mode: DialogMode;
}

export const PageDialogForm = (props: IPageDialogFormProps) => {
  const { mode } = props;

  return (
    <Fragment>
      <TextInput name="slug" />
      <TextInput name="title" />
      <RichTextEditor name="description" />
      {mode === "edit" && <SelectInput name="pageStatus" options={PageStatus} />}
    </Fragment>
  );
};
